export default __webpack_public_path__ + "static/media/sea-lion.7603cba9.png";